import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import ConversationTab from '../ConversationTab';
import PlaceholderTab from '../PlaceholderTab';
import VideoCallTab from '../VideoCallTab';

// Chat icon for the header
const ChatIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
);

const TabContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: transparent;
  position: relative;
  overflow: hidden;
  min-height: 0;
`;

const TopBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 24px;
  background: rgba(255, 255, 255, 0.9);
  border-bottom: 1px solid rgba(91, 97, 234, 0.1);
  backdrop-filter: blur(10px);
  flex-shrink: 0;
  z-index: 10;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

const PageTitleSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const PageIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(88, 116, 190, 0.8);
  
  svg {
    width: 24px;
    height: 24px;
  }
`;

const PageTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  color: #192947;
  letter-spacing: -0.3px;
`;

const PageSubtitle = styled.span`
  font-size: 13px;
  color: rgba(88, 116, 190, 0.6);
  margin-left: 12px;
  padding-left: 12px;
  border-left: 1px solid rgba(91, 97, 234, 0.2);
`;

const TabContent = styled.div`
  flex: 1;
  background: transparent;
  position: relative;
  overflow: hidden;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;

const TabContainer = ({ conversation, expertId, setConversation, videoCallParams, initialActiveTab = 0 }) => {
  const [activeTab, setActiveTab] = useState(initialActiveTab);

  // Update active tab when initialActiveTab changes (for video call URLs)
  useEffect(() => {
    setActiveTab(initialActiveTab);
  }, [initialActiveTab]);

  const tabs = [
    {
      id: 0,
      title: 'Conversation',
      component: (
        <ConversationTab
          conversation={conversation}
          expertId={expertId}
          setConversation={setConversation}
        />
      )
    }
    // Video Call and WhiteBoard tabs temporarily hidden
    // {
    //   id: 1,
    //   title: 'Video Call',
    //   component: (
    //     <VideoCallTab 
    //       conversation={conversation} 
    //       expertId={expertId}
    //       videoCallParams={videoCallParams}
    //     />
    //   )
    // },
    // {
    //   id: 2,
    //   title: 'WhiteBoard',
    //   component: <PlaceholderTab tabName="WhiteBoard" description="This is a placeholder for the whiteboard feature" />
    // }
  ];

  return (
    <TabContainerWrapper>
      <TopBar>
        <PageTitleSection>
          <PageIcon>
            <ChatIcon />
          </PageIcon>
          <PageTitle>Conversation</PageTitle>
          <PageSubtitle>Chat with your adviser</PageSubtitle>
        </PageTitleSection>
      </TopBar>

      <TabContent>
        {tabs[activeTab].component}
      </TabContent>
    </TabContainerWrapper>
  );
};

export default TabContainer; 